import { AxiosResponse } from 'axios';
import { axiosRequest } from 'core/axios';
import { getHeaders } from 'core/common-methods';
import { createRequestAction, RequestAction } from 'core/utils/actionUtils';
import { PageDTO, UUID } from 'core/utils/BasicModels';
import { Dispatch } from 'redux';
import { ContractDTO } from '../../core/contracts/models';

export const WORKSPACE_CONTRACTS: RequestAction = createRequestAction('GET_WORKSPACE_CONTRACTS_REQUEST');

export const fetchWorkspaceContracts = (workspaceId: UUID, includeWaitingForPayment: boolean = false) => async (dispatch: Dispatch): Promise<PageDTO<ContractDTO>> => {
  try {
    const baseURL = process.env.API_URL;
    dispatch({ type: WORKSPACE_CONTRACTS.REQUEST });
    const endpoint = `/v2/workspaces/${workspaceId}/contracts`;
    const contracts = await axiosRequest
            .get<any, AxiosResponse<PageDTO<ContractDTO>>>(endpoint,
      {
        headers: {
          ...getHeaders().common,
        },
        params: {
          include_waiting_for_payment: includeWaitingForPayment,
        },
        baseURL
      });

    const data = contracts.data;

    dispatch({ type: WORKSPACE_CONTRACTS.SUCCESS, payload: data });

    return data;
  } catch (e) {
    dispatch({ type: WORKSPACE_CONTRACTS.ERROR, payload: e });
    throw e;
  }
};
